__webpack_require__.p = "/mcServerStatus/";